var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoiceMailIcon = function SvgVoiceMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.375 7.5a4.868 4.868 0 0 0-3.51 8.25h-5.73a4.868 4.868 0 1 0-3.51 1.5h12.75a4.875 4.875 0 0 0 0-9.75M2.25 12.375a3.375 3.375 0 1 1 3.375 3.375 3.38 3.38 0 0 1-3.375-3.375m16.125 3.375a3.375 3.375 0 1 1 3.375-3.375 3.383 3.383 0 0 1-3.375 3.375",
    clipRule: "evenodd"
  })));
};
export default SvgVoiceMailIcon;